// extracted by mini-css-extract-plugin
export var divider = "_eu-7";
export var itemsToggle = "_eu-8";
export var mergeModal = "_eu-1";
export var optionCard = "_eu-4";
export var radioGroup = "_eu-6";
export var radioOption = "_eu-0";
export var selected = "_eu-5";
export var shipmentOptions = "_eu-2";
export var tableOptions = "_eu-3";